module.exports = __webpack_public_path__ + "img/real_canadian_superstore.7b0d996b.jpg";